<template>
  <div class="mt-10">
    <div
      class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
      v-if="config.codOrder"
    >
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            COD Order confirmation messages
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Configure whatsapp by adding your number
          </p>
          <div></div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
          <form @submit="handleSubmit">
            <fieldset>
              <legend class="text-base leading-6 font-medium text-gray-900">
                Enable automation
              </legend>

              <div class="mt-4 flex flex-wrap">
                <VSwitch
                  :value="config.codOrder.isEnabled"
                  @input="handleSwitch"
                />
              </div>
              <p class="mt-2 text-sm text-gray-500">
                Automated WhatsApp messages are sent from our approved WhatsApp
                Business API number.
              </p>
            </fieldset>
            <div class="grid grid-cols-3 gap-6 mt-5">
              <div class="col-span-3 sm:col-span-2">
                <div>
                  <label
                    for="phone_number"
                    class="block text-sm font-medium leading-5 text-gray-700"
                  >
                    Phone Number
                  </label>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <vue-tel-input
                      :value="phoneNumber"
                      mode="international"
                      @input="handlePhoneNumberUpdate"
                    />
                    <p class="mt-2 text-sm text-gray-500">
                      We will share this number as a link where customers can
                      reply to you if they have any concerns.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-3 gap-6 mt-5">
              <div class="col-span-3 sm:col-span-2">
                <label
                  for="location"
                  class="block text-sm leading-5 font-medium text-gray-700"
                  >Language</label
                >
                <select
                  id="location"
                  class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  v-model="config.codOrder.messageLanguage"
                >
                  <option
                    v-for="(language, index) in templates"
                    :key="index"
                    :value="language.elementName"
                    >{{ language.name }}</option
                  >
                </select>
              </div>
            </div>
            <div class="mt-6">
              <label
                for="about"
                class="block text-sm leading-5 font-medium text-gray-700"
              >
                Message
              </label>
              <div class="rounded-md shadow-sm">
                <textarea
                  id="about"
                  rows="8"
                  class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 cursor-not-allowed bg-gray-100"
                  :value="currentTemplate"
                  :disabled="true"
                ></textarea>
              </div>
            </div>
            <div class="mt-4 sm:mt-0 sm:col-span-2">
              <div class="mt-8 border-t border-gray-200 pt-5">
                <div class="flex justify-end">
                  <span class="ml-3 inline-flex rounded-md shadow-sm">
                    <button
                      type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                      @click="save"
                    >
                      Save
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md my-4 p-4 shadow-md">
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start   sm:pt-5">
          <label
            for="first-name"
            class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
          >
            Order confirmed tag
          </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input
              :value="config.codOrder.orderConfirmedTag"
              type="text"
              disabled
              class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md border p-2 bg-gray-100 cursor-not-allowed"
            />
            <p class="mt-2 text-sm text-gray-500">
              We will add this tag once the customer confirms the order
            </p>
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5">
          <label
            for="last-name"
            class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
          >
            Order not responded tag
          </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input
              type="text"
              :value="config.codOrder.orderNotRespondedTag"
              class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md border p-2 bg-gray-100 cursor-not-allowed"
            />
            <p class="mt-2 text-sm text-gray-500">
              We will add this tag when the customer didn't confirm the order
              within 24 hours
            </p>
          </div>
        </div>
      </div>
      <Notification :text="notificationText" :show="showNotification" />
    </div>
    <OptinOnboarding :title="optinTitle" />
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import VSwitch from "../../components/Common/VSwitch";

import Notification from "../../components/Common/Notification";
import OptinOnboarding from "../../components/Common/OptinOnboarding.vue";

export default {
  name: "CodOrder",
  components: {
    VueTelInput,
    VSwitch,
    Notification,
    OptinOnboarding
  },
  data() {
    return {
      phoneNumber: "",
      notificationText: "",
      showNotification: false,
      config: {},
      templates: [],
      optinTitle: "Please complete the mandatory WhatsApp opt-in steps."
    };
  },
  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template =>
          template.elementName === this.config.codOrder.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }
      return template?.message;
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.config = response.config;
        this.templates = response.codOrderTemplates;
        this.phoneNumber = this.config.phoneNumber;
        this.isLoading = false;
      });
    },
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, { number, isValid, country }) {
      if (isValid) {
        console.log(number, isValid, country);
        this.config.phoneNumber = number.e164;
      }
    },
    save() {
      if (this.hasMoreCharacters) {
        alert("Button Label should be less than 12 characters");
        return;
      }
      if (
        this.config.orderConfirmation.includeDiscountCoupon &&
        (!this.config.orderConfirmation.couponCode ||
          this.config.orderConfirmation.couponCode.length == 0)
      ) {
        alert("Please add a discount code");
        return;
      }
      this.updateConfig();
    },
    handleSwitch(value) {
      this.config.codOrder.isEnabled = value;
    },
    updateConfig() {
      const automationConfig = { ...this.config };
      this.$store
        .dispatch("updateAutomationConfig", {
          requestParams: automationConfig
        })
        .then(() => {
          this.displayNotification("settings updated");
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isAutomatedCODOrderConfirmationVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
